module.exports = __webpack_public_path__ + "img/message-active.c96fee31.svg";